import { Typography, Box } from "@mui/material";

import { TrackingFile } from "@/hooks/files/useFileUploadState";

export function FailedFiles({ files }: { files: TrackingFile[] }) {
  return (
    <>
      <Typography pt={2} variant="subtitle2" color="error.main">
        Failed files
      </Typography>
      <ul>
        {files.map(({ trackingId, file, errorMessages = [] }) => (
          <Box component="li" sx={{ py: 0.75 }} key={trackingId}>
            {file.name} - {file.size} bytes
            {errorMessages.length > 0 && (
              <ul>
                {errorMessages.map((message) => (
                  <Box component="li" color="text.disabled" key={message}>
                    {message}
                  </Box>
                ))}
              </ul>
            )}
          </Box>
        ))}
      </ul>
    </>
  );
}
